import { useQuery } from '@tanstack/react-query';
import { API_URL } from '../../../config';
import { toApiError } from '../../../lib/api-error';
import type { SiteGraph } from '../types';

export type SiteGraphFetch = (
  input: string | URL | Request,
  init?: RequestInit
) => Promise<Response>;

type FetchSiteGraphOptions = {
  apiUrl?: string;
  fetchFn?: SiteGraphFetch;
};

export async function fetchSiteGraph(
  propertyId: string,
  { apiUrl = API_URL, fetchFn = fetch }: FetchSiteGraphOptions = {}
): Promise<SiteGraph> {
  const res = await fetchFn(`${apiUrl}/properties/${propertyId}/site-graph`, {
    credentials: 'include',
  });
  if (!res.ok) throw await toApiError(res, 'Failed to fetch site graph');
  const json = await res.json();
  return json.data as SiteGraph;
}

export function useSiteGraph(propertyId: string | undefined) {
  return useQuery({
    queryKey: ['site-graph', propertyId],
    queryFn: async () => {
      if (!propertyId) throw new Error('Missing property ID');
      return fetchSiteGraph(propertyId);
    },
    enabled: !!propertyId,
    staleTime: 5 * 60 * 1000,
  });
}
